<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--purpose form-wrap__title--sticky">Реквизиты банка для получения микрокредита</h1>

                <div class="form-wrap__row form-wrap__row--extra-padding" v-if="banksList" >
                    <c-radio-group v-model="bankID" :valueList="banksList" :label="'Банк'" :fieldName="'bank'"></c-radio-group>
                </div>


                <div class="form-wrap__row" v-if="bankID">
                    <c-input
                            :label="'IBAN'"
                            :type="'text'"
                            :fieldName="'IBAN'"
                            :validation="''"
                            :mask="'KZ-XXXX-XXXX-XXXX-XXXX-XX'"
                            :externalError="IBANExternalError"
                            :externalStatus="IBANExternalStatus"
                            v-model="IBAN"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>


                <div class="form-wrap__row">
                    <div class="form-button__wrap">
                        <button class="form-button form-button--violet" v-on:click="makeRemittance">
                            Продолжить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';
    import productAdapter from '@/modules/productAdapter'
    import Helpers from '@/modules/Helpers';
    import moment from 'moment';
    import 'moment/locale/ru';
    import each from 'lodash/each'
    import {STATUSES} from "../../../components/statuses";
    import Raven from 'raven-js'

    const {mapFields: calculatorFields} = createHelpers({
        getterType: 'calculator/getField',
        mutationType: 'calculator/updateField',
    });
    const {mapFields: creditFields} = createHelpers({
        getterType: 'credit/getField',
        mutationType: 'credit/updateField',
    });


    export default {
        name: 'Obtaining',
        data() {
            return {
                banksList: null
            }
        },
        methods: {
            makeRemittance: function () {
                let _this = this;
                let data = new URLSearchParams();
                data.append('creditId', this.creditID);
                data.append('bankId', this.bankID);
                data.append('iban', this.IBAN.replace(/-/g , ""));

                this.$http.post('/json/payment/onlinebank/create-remittance', data).then(
                    response => {
                        if(response.data.code === 0){
                            Raven.captureMessage('Step end: '+_this.$options.name, {
                                level: 'info'
                            });
                            this.$router.push({name: 'Confirmation'});
                        }else if( response.data.code === 100){
                            if(response.data.validationErrors.iban === 'borrower.iban.invalid'){
                                _this.$validator.errors.add(
                                    'IBAN',
                                    'Некорректный IBAN'
                                );
                                _this.IBANExternalStatus = STATUSES.LOAD_ERROR;

                            }
                        }
                    },
                    response => {

                    }
                )
            }
        },
        watch: {
          IBAN:function(newVal, oldVal) {
              if(newVal !== oldVal){
                  this.IBAN = newVal.toUpperCase();
              }
          }
        },
        computed: {
            formatAmount: function () {
                return this.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },
            formatTerm: function () {
                let date = moment().add(this.term, 'months').format("DD.MM.YYYY");
                return this.term + ' ' + Helpers.declension(['месяц', 'месяца', 'месяцев'], this.term)+' ('+date+')';
            },
            ...creditFields([
                'creditID',
                'bankID',
                'IBAN',
                'IBANExternalStatus',
                'IBANExternalError',
            ]),
            ...calculatorFields([
                'amount',
                'amountExternalStatus',
                'amountExternalError',

                'term',
                'termExternalStatus',
                'termExternalError',

                'creditType',
                'creditTypeExternalStatus',
                'creditTypeExternalError',

                'purpose',
                'purposeExternalStatus',
                'purposeExternalError',

                'productID'
            ]),
        },
        beforeCreate(){
            if( !this.$store.getters['profile/isInited'] ){
                this.$store.dispatch('profile/INIT');
            }
        },
        mounted() {
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 80, nextPercent: 5});
            this.$store.dispatch('credit/GET_CREDIT_INFO');
            let _this = this;
            _this.IBANExternalStatus = STATUSES.EMPTY;
            _this.IBANExternalError.haveError =  false;
            _this.IBANExternalError.errorText = '';
            this.$http.get('/json/bank').then(
                response => {
                    if(response.data.code === 0){
                        _this.banksList = [];
                        each(response.data.data, function (item, key) {
                            _this.banksList.push({
                                label: item.name,
                                value: item.id
                            })
                        });
                    }
                },
                response => {

                }
            )
        }
    }
</script>

<style lang="scss">

</style>